import { render, staticRenderFns } from "./updateSfHouse.vue?vue&type=template&id=4a5c52d0&scoped=true"
import script from "./updateSfHouse.vue?vue&type=script&lang=js"
export * from "./updateSfHouse.vue?vue&type=script&lang=js"
import style0 from "./updateSfHouse.vue?vue&type=style&index=0&id=4a5c52d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5c52d0",
  null
  
)

export default component.exports